module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.service_history), function(history, index) {
    return _c('div', {
      staticClass: "box"
    }, [_c('article', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(history.title))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('pre', {
      domProps: {
        "innerHTML": _vm._s(history.history)
      }
    })]), (history.files.length > 0) ? _c('article', {
      staticClass: "media"
    }, [(history.showFiles == false) ? [_c('a', {
      staticClass: "button",
      on: {
        "click": function($event) {
          return _vm.loadFiles(history, index)
        }
      }
    }, [_vm._m(0, true), _c('span', [_vm._v("Show attachments (" + _vm._s(history.files.length) + ")")])])] : [_c('div', {
      staticClass: "columns is-multiline"
    }, [_vm._m(1, true), _vm._v(" "), _vm._l((history.history_files), function(file) {
      return [_c('div', {
        staticClass: "column is-12",
        staticStyle: {
          "text-align": "center"
        }
      }, [(file['ext'].toLowerCase() == 'jpg' || file['ext'].toLowerCase() == 'gif' || file['ext'].toLowerCase() == 'png' || file['ext'].toLowerCase() == 'jpeg') ? [_c('a', {
        staticStyle: {
          "border-bottom": "none"
        },
        attrs: {
          "href": file['url'],
          "target": "_blank"
        }
      }, [_c('img', {
        attrs: {
          "src": file['url'],
          "alt": "",
          "width": "90%"
        }
      })])] : [_c('a', {
        staticStyle: {
          "border-bottom": "none"
        },
        attrs: {
          "href": file['url'],
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa fa-file-o fa-4",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v("\n                              " + _vm._s(file['name']) + "\n                            ")])]], 2), _vm._v(" "), _c('div', {
        staticClass: "column is-12"
      }, [_c('article', {
        staticClass: "media"
      })])]
    })], 2)]], 2) : _vm._e(), _vm._v(" "), _c('small', [_vm._v(_vm._s(history.user.name))]), _vm._v(" "), _c('small', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("Created: " + _vm._s(history.created_at))]), _vm._v(" "), _c('p')])])])])
  }), 0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-12"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Attachments")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4896b0a7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/services/History.vue
// module id = 1126
// module chunks = 39